/**
 * useMasterAccessScope — périmètre d'action du COLLABORATEUR connecté sur
 * l'interface master (rectorium_team_members.master_access_scope, défini par
 * le Master dans la fiche modale de l'Annuaire — demande Alfred 2026-07-12).
 *
 * Retourne { scope, loaded } : scope = null → accès complet (défaut, y compris
 * si la colonne n'existe pas encore ou si l'opérateur n'est pas dans
 * l'annuaire) ; tableau d'ids MASTER_NAV → périmètre restreint.
 * Cache module : une seule requête par session, invalidée au changement d'auth.
 */
import { createMasterTeamFieldHook } from './masterTeamFieldCache';

const [useMasterAccessScope, invalidateMasterAccessScopeCache] = createMasterTeamFieldHook({
  column: 'master_access_scope',
  resultKey: 'scope',
  mapValue: (raw) => (Array.isArray(raw) ? raw : null),
  defaultValue: null,
});

export default useMasterAccessScope;
/** Invalide le cache (après édition d'un périmètre dans l'Annuaire, ou au logout). */
export { invalidateMasterAccessScopeCache };
